import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import MetaTags from '../components/common/MetaTags';
import MainTitle from '../components/common/MainTitle';
import ApplyForm from '../components/Apply/ApplyForm';
import scrollToTarget from '../js/utils/scroll';

export default function ApplyPage() {
  const { t } = useTranslation(['ApplyPage']);

  useEffect(() => {
    const el = document?.getElementById('apply-page');
    scrollToTarget(el);
  }, []);

  return (
    <main className="apply-page" id="apply-page">
      <MetaTags title={t('pageTitle')} />

      <section className="apply-page__hero container">
        <MainTitle type="dark" className="text--2xl">
          <span>{t('heroTitle1')}</span>
          <span className="decorated-line decorated-line--dark decorated-line--left">
            {t('heroTitle2')}
          </span>
        </MainTitle>
        <p className="apply-page__subtitle">{t('heroSubtitle')}</p>
      </section>

      <section className="apply-page__form container">
        <ApplyForm />
      </section>
    </main>
  );
}
